<template>
  <header class="header" :class="{ scrolled: scrolled }">
    <div class="wrap bar">
      <router-link to="/" class="brand">
        <span class="mark mono">苏</span>
        <span class="brand-text">
          <b>职业选手苏屠</b>
          <i>回馈新老粉丝福利</i>
        </span>
      </router-link>

      <nav class="nav" :class="{ open: menuOpen }">
        <router-link to="/" class="nav-link" @click="close">首页</router-link>
        <router-link
          v-for="c in categories"
          :key="c.key"
          :to="`/task/${c.key}`"
          class="nav-link"
          @click="close"
        >
          {{ c.name }}
        </router-link>
        <a class="nav-link nav-link--other" href="#upcoming" @click="close">其它挣米业务</a>
      </nav>

      <div class="actions">
        <span class="hot"><i></i>今日已发放 ¥68,520</span>
        <button class="btn btn-primary btn-sm" @click="goFirst">立即赚米</button>
        <button class="burger" :class="{ open: menuOpen }" @click="menuOpen = !menuOpen" aria-label="菜单">
          <span></span><span></span><span></span>
        </button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { categories } from '@/data/site'

const router = useRouter()
const scrolled = ref(false)
const menuOpen = ref(false)

const onScroll = () => {
  scrolled.value = window.scrollY > 12
}

onMounted(() => {
  onScroll()
  window.addEventListener('scroll', onScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
})

const close = () => {
  menuOpen.value = false
}

const goFirst = () => {
  menuOpen.value = false
  const first = categories[0]
  if (first) router.push(`/task/${first.key}`)
}
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 50;
  backdrop-filter: blur(14px);
  background: rgba(10, 9, 8, 0.72);
  border-bottom: 1px solid transparent;
  transition: border-color 0.3s ease, background 0.3s ease;
}

.header.scrolled {
  border-bottom-color: var(--border);
  background: rgba(10, 9, 8, 0.9);
}

.bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  height: 74px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.mark {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  font-size: 22px;
  font-weight: 700;
  color: #241300;
  background: var(--grad-gold);
  box-shadow: 0 8px 20px rgba(255, 158, 44, 0.36);
}

.brand-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.brand-text b {
  font-size: 17px;
  letter-spacing: 0.02em;
}

.brand-text i {
  font-style: normal;
  font-size: 11px;
  color: var(--muted);
  letter-spacing: 0.28em;
}

.nav {
  display: flex;
  align-items: center;
  gap: 6px;
}

.nav-link {
  position: relative;
  padding: 9px 14px;
  border-radius: 10px;
  font-size: 14.5px;
  color: var(--muted);
  transition: color 0.2s ease, background 0.2s ease;
}

.nav-link:hover {
  color: var(--text);
  background: rgba(255, 255, 255, 0.05);
}

.nav-link.router-link-exact-active {
  color: var(--gold);
}

.nav-link--other {
  color: var(--gold-2);
}

.actions {
  display: flex;
  align-items: center;
  gap: 14px;
}

.hot {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 12.5px;
  color: var(--muted);
  white-space: nowrap;
}

.hot i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #4ecb7a;
  box-shadow: 0 0 0 0 rgba(78, 203, 122, 0.6);
  animation: pulse 1.8s infinite;
}

.btn-sm {
  padding: 10px 20px;
  font-size: 14px;
}

.burger {
  display: none;
  flex-direction: column;
  gap: 5px;
  padding: 8px;
}

.burger span {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--text);
  border-radius: 2px;
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.burger.open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.burger.open span:nth-child(2) {
  opacity: 0;
}

.burger.open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(78, 203, 122, 0.6);
  }
  100% {
    box-shadow: 0 0 0 8px rgba(78, 203, 122, 0);
  }
}

@media (max-width: 1024px) {
  .hot {
    display: none;
  }
  .nav {
    position: absolute;
    top: 74px;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 2px;
    padding: 12px 16px 20px;
    background: rgba(10, 9, 8, 0.98);
    border-bottom: 1px solid var(--border);
    transform: translateY(-12px);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.22s ease, transform 0.22s ease;
  }
  .nav.open {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }
  .nav-link {
    padding: 13px 14px;
  }
  .burger {
    display: flex;
  }
}

@media (max-width: 640px) {
  .bar {
    height: 64px;
  }
  .brand-text i {
    display: none;
  }
  .nav {
    top: 64px;
  }
  .btn-sm {
    padding: 9px 16px;
    font-size: 13px;
  }
}
</style>
